import React, { useState } from 'react';
import { ExternalLink, ArrowUpRight } from 'lucide-react';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import Seo from '../components/Seo.jsx';

const PRESS = [
  {
    id: 1,
    publication: 'Le Monde',
    publicationFull: 'Le Monde Afrique',
    logo: 'Assets/As seen on/Le_monde_logo.svg.png',
    flag: '🇫🇷',
    date: 'October 9, 2025',
    headline: 'À Nairobi, les Drunken Lectures abreuvent les débats de société',
    headlineEn: "In Nairobi, Drunken Lectures fuel society's debates",
    excerpt:
      'Dans un bar branché de Nairobi, des centaines de Kényans se pressent chaque mois pour écouter des conférences sur l\'histoire, la politique et la culture — le tout, verre en main.',
    excerptEn:
      'In a trendy Nairobi bar, hundreds of Kenyans gather every month to attend lectures on history, politics and culture — drinks in hand.',
    url: 'https://www.lemonde.fr/afrique/article/2025/10/09/a-nairobi-les-drunken-lectures-abreuvent-les-debats-de-societe_6645408_3212.html',
    accent: '#E63946',
    tag: 'Feature',
    featured: true,
  },
  {
    id: 2,
    publication: 'Africa Is A Country',
    publicationFull: 'Africa Is A Country',
    logo: 'Assets/As seen on/Logo_of_Africa_Is_a_Country.png',
    flag: '🌍',
    date: 'December 2025',
    headline: 'Pints and Powerpoints',
    headlineEn: 'Pints and Powerpoints',
    excerpt:
      'What happens when you take the stuffiness out of intellectual discourse, add craft beer, and invite Nairobi to think out loud? You get Drunken Lectures — and a packed room every single time.',
    excerptEn:
      'What happens when you take the stuffiness out of intellectual discourse, add craft beer, and invite Nairobi to think out loud? You get Drunken Lectures — and a packed room every single time.',
    url: 'https://africasacountry.com/2025/12/pints-and-powerpoints',
    accent: '#2D6A4F',
    tag: 'Culture',
    featured: true,
  },
  {
    id: 3,
    publication: 'Citizen Digital',
    publicationFull: 'Citizen Digital Kenya',
    logo: 'Assets/As seen on/CitizenDigital-logo.png',
    flag: '🇰🇪',
    date: '2025',
    headline: 'Drunken Lecturers Kenya: A New Way to Learn and Socialize',
    headlineEn: 'Drunken Lecturers Kenya: A New Way to Learn and Socialize',
    excerpt:
      'Combining stimulating intellectual debate with a lively social atmosphere, Drunken Lectures is reshaping how Nairobi engages with knowledge — and each other.',
    excerptEn:
      'Combining stimulating intellectual debate with a lively social atmosphere, Drunken Lectures is reshaping how Nairobi engages with knowledge — and each other.',
    url: 'https://citizen.digital/article/drunken-lecturers-kenya-a-new-way-to-learn-and-socialize-n359866',
    accent: '#E8672E',
    tag: 'Interview',
    featured: false,
  },
  {
    id: 4,
    publication: 'Nation Africa',
    publicationFull: 'Nation Africa',
    logo: 'Assets/As seen on/dn-logo-svg-data.svg',
    flag: '🇰🇪',
    date: '2025',
    headline: 'Drunken Lectures come to Nairobi: A new kind of fun for nerds',
    headlineEn: 'Drunken Lectures come to Nairobi: A new kind of fun for nerds',
    excerpt:
      'For those who find nightlife too loud and libraries too quiet, Drunken Lectures has carved out the perfect middle ground in the heart of Nairobi.',
    excerptEn:
      'For those who find nightlife too loud and libraries too quiet, Drunken Lectures has carved out the perfect middle ground in the heart of Nairobi.',
    url: 'https://nation.africa/kenya/life-and-style/drunken-lectures-come-to-nairobi-a-new-kind-of-fun-for-nerds-4985386#story',
    accent: '#1D3557',
    tag: 'Lifestyle',
    featured: false,
  },
  {
    id: 5,
    publication: 'EPD Video',
    publicationFull: 'EPD Video',
    logo: null,
    flag: '🇩🇪',
    date: '2025',
    headline: 'Drunken Lectures: Wie Kenias Jugend die Bar zum Hörsaal macht',
    headlineEn: 'Drunken Lectures: How Kenya\'s youth turn the bar into a lecture hall',
    excerpt:
      'A German media feature on how Drunken Lectures is reshaping intellectual culture in Nairobi — one bar, one lecture at a time.',
    excerptEn:
      'A German media feature on how Drunken Lectures is reshaping intellectual culture in Nairobi — one bar, one lecture at a time.',
    url: 'https://www.epd-video.de/themen/beitrag/drunken-lectures-wie-kenias-jugend-die-bar-zum-hoersaal-macht',
    accent: '#4A90D9',
    tag: 'International',
    featured: false,
  },
  {
    id: 6,
    publication: 'Reddit r/nairobi',
    publicationFull: 'Reddit — r/nairobi',
    logo: null,
    flag: '🌐',
    date: '2025',
    headline: 'Drunken Lectures Monday',
    headlineEn: 'Drunken Lectures Monday',
    excerpt:
      'The Nairobi subreddit weighs in on Drunken Lectures — community reactions, memories, and why it keeps selling out.',
    excerptEn:
      'The Nairobi subreddit weighs in on Drunken Lectures — community reactions, memories, and why it keeps selling out.',
    url: 'https://www.reddit.com/r/nairobi/comments/1nxl2jb/drunken_lectures_monday/',
    accent: '#FF4500',
    tag: 'Community',
    featured: false,
  },
];

const LOGOS = [
  { name: 'Le Monde',            img: 'Assets/As seen on/Le_monde_logo.svg.png', height: 100 },
  { name: 'Africa Is A Country', img: 'Assets/As seen on/Logo_of_Africa_Is_a_Country.png', height: 100 },
  { name: 'Citizen Digital',     img: 'Assets/As seen on/CitizenDigital-logo.png', height: 100 },
  { name: 'Nation Africa',       img: 'Assets/As seen on/dn-logo-svg-data.svg',  height: 100 },
];

export default function News() {
  const [hoveredId, setHoveredId] = useState(null);
  const [showTranslation, setShowTranslation] = useState({});

  const toggleTranslation = (id) => {
    setShowTranslation(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const featured = PRESS.filter(p => p.featured);
  const rest = PRESS.filter(p => !p.featured);

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif", background: '#FFFFFF', minHeight: '100vh', margin: 0 }}>
      <Seo title="News" description="Drunken Lectures in the press — coverage from Le Monde Afrique and other publications." path="/news" />
      <Navbar />

      {/* ── HERO ── */}
      <section style={{ paddingTop: '72px', background: '#0D0D0D', position: 'relative', overflow: 'hidden' }}>
        <img
          src="/Assets/News image.jpg"
          alt="News"
          style={{ width: '100%', maxHeight: '520px', objectFit: 'cover', objectPosition: 'center', display: 'block', filter: 'grayscale(100%)' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <h1 style={{
            color: '#FFFFFF', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif", fontSize: 'clamp(2.8rem, 7vw, 5rem)', fontWeight: '600',
            letterSpacing: '-0.02em', margin: 0, textAlign: 'center',
          }}>
            News
          </h1>
        </div>
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '80px', background: 'linear-gradient(to bottom, transparent, #FFFFFF)' }} />
      </section>

      {/* ── AS SEEN IN logo strip ── */}
      <section style={{ background: '#F5EFE6', borderTop: '1px solid rgba(0,0,0,0.06)', borderBottom: '1px solid rgba(0,0,0,0.06)', padding: '2.2rem 1.5rem' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <p style={{ textAlign: 'center', color: '#999', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '1.8rem' }}>
            As seen in
          </p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3rem', flexWrap: 'wrap' }}>
            {LOGOS.map((logo, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img
                  loading="lazy"
                  decoding="async"
                  src={logo.img}
                  alt={logo.name}
                  className="press-logo"
                  style={{
                    width: '160px',
                    maxWidth: '220px',
                    height: `${logo.height}px`,
                    objectFit: 'contain',
                    filter: 'grayscale(100%)',
                    opacity: 0.75,
                    transition: 'filter 0.25s ease, opacity 0.25s ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.filter = 'grayscale(0%)'; e.currentTarget.style.opacity = '1'; }}
                  onMouseLeave={e => { e.currentTarget.style.filter = 'grayscale(100%)'; e.currentTarget.style.opacity = '0.75'; }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FEATURED (large cards) ── */}
      <section style={{ padding: '5rem 1.5rem 2rem', maxWidth: '1100px', margin: '0 auto' }}>
        <p style={{ color: '#999', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '2rem' }}>
          Featured Coverage
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem' }}>
          {featured.map(item => (
            <FeaturedCard
              key={item.id}
              item={item}
              hovered={hoveredId === item.id}
              onEnter={() => setHoveredId(item.id)}
              onLeave={() => setHoveredId(null)}
              showTranslation={showTranslation[item.id]}
              onToggle={() => toggleTranslation(item.id)}
            />
          ))}
        </div>
      </section>

      {/* ── OTHER COVERAGE ── */}
      <section style={{ padding: '2rem 1.5rem 6rem', maxWidth: '1100px', margin: '0 auto' }}>
        <p style={{ color: '#999', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '2rem' }}>
          More Coverage
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', background: 'rgba(0,0,0,0.08)', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.08)' }}>
          {rest.map((item, i) => (
            <ListCard
              key={item.id}
              item={item}
              hovered={hoveredId === item.id}
              onEnter={() => setHoveredId(item.id)}
              onLeave={() => setHoveredId(null)}
              isLast={i === rest.length - 1}
            />
          ))}
        </div>
      </section>

      {/* ── MEDIA ENQUIRIES CTA ── */}
      <section style={{ background: '#1C3A56', padding: '5rem 1.5rem' }}>
        <div style={{ maxWidth: '640px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ color: '#E8672E', fontSize: '0.75rem', fontWeight: '700', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '1rem' }}>
            Media Enquiries
          </p>
          <h2 style={{ color: '#FFFFFF', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif", fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: '600', letterSpacing: '-0.02em', margin: '0 0 1.2rem' }}>
            Want to cover Drunken Lectures?
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '1rem', lineHeight: 1.7, marginBottom: '2.5rem' }}>
            We welcome press, journalists, and content creators. Reach out and we'll make it happen.
          </p>
          <a
            href="/contact"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              background: '#E8672E', color: '#FFFFFF',
              padding: '0.9rem 2.2rem', borderRadius: '50px',
              fontWeight: '700', fontSize: '0.9rem', letterSpacing: '0.04em',
              textDecoration: 'none', textTransform: 'uppercase',
              transition: 'background 0.2s ease, transform 0.2s ease',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#e85a22'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#E8672E'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Get in Touch <ArrowUpRight size={16} />
          </a>
        </div>
      </section>

      <Footer />

      <style>{`
        * { box-sizing: border-box; }
        @media (max-width: 600px) {
          .press-logo { width: 110px !important; height: 60px !important; }
        }
        @media (max-width: 480px) {
          .list-card-pub { min-width: 0 !important; width: 100% !important; }
          .list-card-divider { display: none !important; }
        }
      `}</style>
    </div>
  );
}

function FeaturedCard({ item, hovered, onEnter, onLeave, showTranslation, onToggle }) {
  const isNonEnglish = item.publication === 'Le Monde';

  return (
    <div
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      style={{
        background: '#FFFFFF',
        borderRadius: '20px',
        border: `1.5px solid ${hovered ? item.accent : 'rgba(0,0,0,0.08)'}`,
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.2rem',
        transition: 'border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        boxShadow: hovered ? `0 20px 48px rgba(0,0,0,0.1)` : '0 2px 12px rgba(0,0,0,0.05)',
        cursor: 'default',
      }}
    >
      {/* Top row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          {item.logo
            ? <img loading="lazy" decoding="async" src={item.logo} alt={item.publicationFull} style={{ height: '28px', maxWidth: '140px', objectFit: 'contain', objectPosition: 'left center', display: 'block' }} />
            : <><span style={{ fontSize: '1.1rem' }}>{item.flag}</span><span style={{ marginLeft: '0.5rem', fontWeight: '800', fontSize: '0.95rem', color: '#17140F' }}>{item.publicationFull}</span></>
          }
        </div>
        <span style={{
          background: item.accent + '18', color: item.accent,
          fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.1em',
          textTransform: 'uppercase', padding: '0.3rem 0.7rem', borderRadius: '50px',
        }}>
          {item.tag}
        </span>
      </div>

      {/* Headline */}
      <div>
        <h3 style={{ fontSize: '1.2rem', fontWeight: '800', color: '#17140F', lineHeight: 1.3, margin: '0 0 0.4rem', letterSpacing: '-0.01em' }}>
          {showTranslation ? item.headlineEn : item.headline}
        </h3>
        {isNonEnglish && (
          <button
            onClick={onToggle}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#E8672E', fontSize: '0.72rem', fontWeight: '600',
              padding: 0, letterSpacing: '0.03em', textDecoration: 'underline',
            }}
          >
            {showTranslation ? 'Voir en français' : 'Read in English'}
          </button>
        )}
      </div>

      {/* Excerpt */}
      <p style={{ fontSize: '0.9rem', color: '#555', lineHeight: 1.65, margin: 0, flexGrow: 1 }}>
        {showTranslation ? item.excerptEn : item.excerpt}
      </p>

      {/* Footer */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '1rem', borderTop: '1px solid rgba(0,0,0,0.07)' }}>
        <span style={{ fontSize: '0.78rem', color: '#999', fontWeight: '500' }}>{item.date}</span>
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.35rem',
            color: item.accent, fontWeight: '700', fontSize: '0.8rem',
            textDecoration: 'none', letterSpacing: '0.03em',
            padding: '0.45rem 1rem', borderRadius: '50px',
            border: `1.5px solid ${item.accent}`,
            transition: 'background 0.2s ease, color 0.2s ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = item.accent; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = item.accent; }}
        >
          Read Article <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}

function ListCard({ item, hovered, onEnter, onLeave, isLast }) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      style={{
        display: 'flex', alignItems: 'center', gap: '1.5rem',
        background: hovered ? '#FFFFFF' : '#FAFAF8',
        padding: '1.5rem 1.8rem',
        textDecoration: 'none',
        transition: 'background 0.2s ease',
        flexWrap: 'wrap',
      }}
    >
      {/* Publication */}
      <div className="list-card-pub" style={{ minWidth: '160px', flexShrink: 0 }}>
        {item.logo
          ? <img loading="lazy" decoding="async" src={item.logo} alt={item.publication} style={{ height: '22px', maxWidth: '140px', objectFit: 'contain', objectPosition: 'left center', display: 'block', marginBottom: '0.35rem' }} />
          : <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.35rem' }}>
              <span style={{ fontSize: '0.95rem' }}>{item.flag}</span>
              <span style={{ fontWeight: '800', fontSize: '0.88rem', color: '#17140F' }}>{item.publication}</span>
            </div>
        }
        <span style={{ fontSize: '0.72rem', color: '#999', fontWeight: '500' }}>{item.date}</span>
      </div>

      {/* Divider */}
      <div className="list-card-divider" style={{ width: '1px', height: '40px', background: 'rgba(0,0,0,0.1)', flexShrink: 0 }} />

      {/* Headline + excerpt */}
      <div style={{ flex: 1, minWidth: '200px' }}>
        <p style={{ fontWeight: '700', fontSize: '0.95rem', color: '#17140F', margin: '0 0 0.25rem', lineHeight: 1.3 }}>
          {item.headline}
        </p>
        <p style={{ fontSize: '0.83rem', color: '#777', margin: 0, lineHeight: 1.5 }}>
          {item.excerpt}
        </p>
      </div>

      {/* Arrow */}
      <div style={{
        flexShrink: 0, width: '36px', height: '36px', borderRadius: '50%',
        border: `1.5px solid ${hovered ? item.accent : 'rgba(0,0,0,0.15)'}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'border-color 0.2s ease, background 0.2s ease',
        background: hovered ? item.accent : 'transparent',
      }}>
        <ArrowUpRight size={15} color={hovered ? '#fff' : '#999'} />
      </div>
    </a>
  );
}
